<template>
  <dv-border-box-7>
    <div class="line_title" @click="routerIssueTop()">{{ title }}</div>
    <dv-decoration-10 style="width: 100%; height: 5px" />
    <dv-scroll-board :config="config" />
  </dv-border-box-7>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "oee-prodctline-record",
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.datas = val;
        this.createData();
      },
      deep: true,
    },
    title: {
      handler: function (val, oldVal) {
        this.title = val;
      },
      deep: true,
    },
  },
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
    title: {
      type: String,
      default: function () {
        return "上周影响主要问题";
      },
    },
  },
  data() {
    return {
      datas: this.beans,
      config: {
        //       header: ["发生时间", "问题描述", "持续时间(分)"],
        //       data: [],
        //       columnWidth: [120,380],
        // align: ["center"],
        // rowNum: 6,
        // headerBGC: "rgba(6, 30, 93, 0.5)",
        // headerHeight: 45,
        // oddRowBGC: "rgba(0, 44, 81, 0.8)",
        // evenRowBGC: "rgba(10, 29, 50, 0.8)",
      },
    };
  },
  methods: {
    routerIssueTop() {
      this.$router.push({
        path: "/oee/issue-top",
        query: {
          line: this.$route.query.uuid,
        }
      });
    },
    createData() {
      var dataList = this.datas;
      var data = [];
      for (var i = 0; i < dataList.length; i++) {
        var device = dataList[i]["device"];
        var faiCode = dataList[i]["faiCode"];
        var faiCause =  dataList[i]["faiCause"];
        var productName = dataList[i]["productName"];
        var duration = dataList[i]["duration"];

        if (dataList[i]["unCom"] < 1) {
          device = '<span style="color:#00E690;">' + device + "</span>";
          productName = '<span style="color:#00E690;">' + productName + "</span>";
          faiCause = '<span style="color:#00E690;">' + faiCause + "</span>";
          duration =
            '<span style="color:#00E690;">' + duration +  "</span>";
        }

        var value = [device, productName, faiCause, duration];
        data.push(value);
      }

      this.config = {
        header: ["设备", "产品", "故障说明", "持续时间(分)"],
        data: data,
        columnWidth: [150, 120, 300, 120],
        align: ["left", "left", "left", "center"],
        rowNum: 6,
        headerBGC: "rgba(6, 30, 93, 0.5)",
        headerHeight: 45,
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
      };
    },
    dateFormat(uninx) {
      return dateFormat(uninx, "MM-dd");
    },
  },
};
</script>
<style scoped src='../productLine/board.css'>
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/oee-productline-issue.vue